export type { EventAttributes, EventEvent, EventsAPI, PushEventOptions } from './types';
export { initializeEventsAPI } from './initialize';



// WEBPACK FOOTER //
// ../../../../src/api/events/index.ts